import { get } from 'lodash-es'
import { toWorkflowData } from './toWorkflowData'

export const toMembershipData = (data: Json): MembershipWorkflowData => ({
    laterLink: get(data, 'laterLink'),
    workflow: toWorkflowData(data),
    workflowType: 'membership',
    user: get(data, '_embedded.user'),
})
